// @ts-nocheck
import { CalendarClock, Search, Settings, SquarePlus, User, UserX } from "lucide-react";
import { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FetchUsername } from "./ApiRoutes";

import SearchDialog from "./ui/SearchDialog";
import { UserContext } from "@/App";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import LoginDialog from "./LoginDialog";
import ProfileSettings from "./ProfileSettings";

export default function NavbarMobile () {
    const navigate = useNavigate();
    const {user, setUser} = useContext(UserContext);
 
    const username = user.username || localStorage.getItem("username");
    const avatar = user.avatar || localStorage.getItem("avatar");

    const profileRoute = username ? `/profile/${username}/` : "/";

    const iconWidth = "w-8";
    const iconHeight = "h-8";

    return(
        <nav className="flex w-full h-full bg-black text-white justify-center">
            <div className="flex flex-row justify-evenly items-center w-full">
                {
                    username ?
                     <Link to={`/consumelater/${username}/`}><CalendarClock className={`${iconWidth} ${iconHeight} hover:cursor-pointer`}/></Link>
                    :
                     <LoginDialog><CalendarClock className={`${iconWidth} ${iconHeight} hover:cursor-pointer`}/></LoginDialog>
                }
                
               
                <SearchDialog><Search className={`${iconWidth} ${iconHeight} hover:cursor-pointer`}/></SearchDialog>
                <Link to="/list/edit/"><SquarePlus className={`${iconWidth} ${iconHeight} hover:cursor-pointer`}/></Link>
                {username ?
                    <ProfileSettings>
                        <Settings className="w-7 h-7 hover:cursor-pointer"/>
                    </ProfileSettings>
                    :
                    <LoginDialog>
                        <Settings className="w-7 h-7 hover:cursor-pointer"/>
                    </LoginDialog>
                }
                {username ? 
                    <Link to={profileRoute}>
                        <Avatar className="text-black"> 
                            <AvatarImage className="rounded-full border-2 border-white w-10 h-10" src={avatar ?? undefined} /> 
                            <AvatarFallback className="rounded-full border-2 text-blacke border-white w-10 h-10">:)</AvatarFallback>
                        </Avatar>
                    </Link> 
                        :
                        <LoginDialog>
                            <UserX className="w-7 h-7 hover:cursor-pointer"/>
                        </LoginDialog> 
                }
                       
                        
            </div>
        </nav>
    )
}